var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReportsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17.3,
  height: 13.826,
  viewBox: "0 0 17.3 13.826"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_1778",
  "data-name": "Group 1778",
  transform: "translate(-36.744 -177.574)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M1509.134,347.289c2.289-2.106,4.532-4.3,4.532-4.3l3.113,3.067,6.364-6.867",
  transform: "translate(-1470.745 -161)",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_272",
  "data-name": "Line 272",
  x2: 15.5,
  transform: "translate(37.644 190.5)",
  fill: "none",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeWidth: 1.8
}))));
export { SvgReportsIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/reportsIcon.dbdfe8dda1c760fa4f7e6d77a281f3cf.svg";